module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "xs": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "id": "yesterday"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(2)
      }
    }
  }, [_vm._v("前天")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.typeChange
    },
    model: {
      value: (_vm.pdata.type),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "type", $$v)
      },
      expression: "pdata.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "非矩阵",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "矩阵",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "换量",
      "value": "3"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchAddProduct
    }
  }, [_vm._v("导入")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "text"
    },
    on: {
      "click": _vm.downloadTemp
    }
  }, [_vm._v("导入模板下载")])], 1)], 1)], 1), _vm._v(" "), (_vm.dateVal[0] !== _vm.dateVal[1] && _vm.isFetch) ? _c('el-table', {
    staticClass: "selfTable",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "row-key": "issued_app_id",
      "show-summary": "",
      "summary-method": _vm.getSummaries,
      "height": _vm.height,
      "row-class-name": _vm.tableRowClassName,
      "default-sort": {
        prop: '_visit_uv_new',
        order: 'descending'
      }
    },
    on: {
      "expand-change": _vm.expands
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('el-table', {
          attrs: {
            "data": s.row.exData,
            "show-header": false
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "d_date",
            "label": "",
            "align": "center",
            "width": "48px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(" ")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "d_date",
            "label": "日期",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "d_date",
            "label": "",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(" ")])]
            }
          }], null, true)
        }), _vm._v(" "), (_vm.pdata.type != 3) ? _c('el-table-column', {
          attrs: {
            "prop": "visit_uv_new",
            "label": "预计新增用户",
            "align": "center"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.pdata.type != 3) ? _c('el-table-column', {
          attrs: {
            "prop": "cost",
            "label": "预计花费",
            "align": "center",
            "formatter": _vm.fixed2Formatter
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                    \t￥"), _c('span', [_vm._v(_vm._s(scope.row.cost))])]
            }
          }], null, true)
        }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "_visit_uv_new",
            "label": "实际计价用户",
            "align": "center"
          }
        }), _vm._v(" "), (_vm.pdata.type == 3) ? _c('el-table-column', {
          attrs: {
            "prop": "_visit_uv",
            "label": "实际活跃用户",
            "align": "center"
          }
        }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "_cost",
            "label": "实际花费",
            "align": "center",
            "formatter": _vm.fixed2Formatter
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                    \t￥"), _c('span', [_vm._v(_vm._s(scope.row._cost))])]
            }
          }], null, true)
        }), _vm._v(" "), (_vm.pdata.type != 3) ? _c('el-table-column', {
          attrs: {
            "prop": "cost_per",
            "label": "实际买量单价",
            "align": "center",
            "formatter": _vm.fixed2Formatter
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                    \t￥"), _c('span', [_vm._v(_vm._s(scope.row.cost_per))])]
            }
          }], null, true)
        }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "",
            "label": "",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(" ")])]
            }
          }], null, true)
        })], 1)]
      }
    }], null, false, 814283293)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "issued_app_id",
      "label": "ID",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "app_name",
      "label": "发行游戏名称",
      "align": "center"
    }
  }), _vm._v(" "), (_vm.list.length > 0 && _vm.list[0].visit_uv_new != undefined && _vm.pdata.type != 3) ? _c('el-table-column', {
    attrs: {
      "prop": "visit_uv_new",
      "label": "预计新增用户",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.visit_uv_new - 0) - (b.visit_uv_new - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "red"
        }, [_vm._v(_vm._s(scope.row.visit_uv_new))])]
      }
    }], null, false, 884798333)
  }) : _vm._e(), _vm._v(" "), (_vm.list.length > 0 && _vm.list[0].cost != undefined && _vm.pdata.type != 3) ? _c('el-table-column', {
    attrs: {
      "prop": "cost",
      "label": "预计花费",
      "formatter": _vm.fixed2Formatter,
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.cost - 0) - (b.cost - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          \t￥"), _c('span', {
          staticClass: "red"
        }, [_vm._v(_vm._s(scope.row.cost))])]
      }
    }], null, false, 4160565443)
  }) : _vm._e(), _vm._v(" "), (_vm.list.length > 0 && _vm.list[0]._visit_uv_new != undefined) ? _c('el-table-column', {
    attrs: {
      "prop": "_visit_uv_new",
      "label": "实际计价用户",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a._visit_uv_new - 0) - (b._visit_uv_new - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: scope.row.gray ? 'gray-text' : 'red'
        }, [_vm._v(_vm._s(scope.row._visit_uv_new))])]
      }
    }], null, false, 714932911)
  }) : _vm._e(), _vm._v(" "), (_vm.list.length > 0 && _vm.list[0]._visit_uv != undefined && _vm.pdata.type == 3) ? _c('el-table-column', {
    attrs: {
      "prop": "_visit_uv",
      "label": "实际活跃用户",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a._visit_uv - 0) - (b._visit_uv - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: scope.row.gray ? 'gray-text' : 'red'
        }, [_vm._v(_vm._s(scope.row._visit_uv))])]
      }
    }], null, false, 3331388876)
  }) : _vm._e(), _vm._v(" "), (_vm.list.length > 0 && _vm.list[0]._cost != undefined) ? _c('el-table-column', {
    attrs: {
      "prop": "_cost",
      "label": "实际花费",
      "formatter": _vm.fixed2Formatter,
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a._cost - 0) - (b._cost - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          \t￥"), _c('span', {
          class: scope.row.gray ? 'gray-text' : 'red'
        }, [_vm._v(_vm._s(_vm.fixed2Formatter('', '', scope.row._cost)))])]
      }
    }], null, false, 1363077460)
  }) : _vm._e(), _vm._v(" "), (_vm.list.length > 0 && _vm.list[0].cost_per != undefined && _vm.pdata.type != 3) ? _c('el-table-column', {
    attrs: {
      "prop": "cost_per",
      "label": "实际买量单价",
      "formatter": _vm.fixed2Formatter,
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.cost_per - 0) - (b.cost_per - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          \t￥"), _c('span', {
          staticClass: "red"
        }, [_vm._v(_vm._s(scope.row.cost_per))])]
      }
    }], null, false, 3270957691)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '成本日报详情',
                params: {
                  issued_app_id: scope.row.issued_app_id
                },
                query: {
                  sdate: _vm.pdata.sdate,
                  edate: _vm.pdata.edate
                }
              })
            }
          }
        }, [_vm._v("详情")])]
      }
    }], null, false, 919610758)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.dateVal[0] === _vm.dateVal[1] && _vm.isFetch) ? _c('el-table', {
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "row-key": "issued_app_id",
      "show-summary": "",
      "summary-method": _vm.getSummaries,
      "height": _vm.height,
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "issued_app_id",
      "label": "ID",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "app_name",
      "label": "发行游戏名称",
      "align": "center"
    }
  }), _vm._v(" "), (_vm.list.length > 0 && _vm.list[0].visit_uv_new != undefined && _vm.pdata.type != 3) ? _c('el-table-column', {
    attrs: {
      "prop": "visit_uv_new",
      "label": "预计新增用户",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.visit_uv_new - 0) - (b.visit_uv_new - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "red"
        }, [_vm._v(_vm._s(scope.row.visit_uv_new))])]
      }
    }], null, false, 884798333)
  }) : _vm._e(), _vm._v(" "), (_vm.list.length > 0 && _vm.list[0].cost != undefined && _vm.pdata.type != 3) ? _c('el-table-column', {
    attrs: {
      "prop": "cost",
      "label": "预计花费",
      "formatter": _vm.fixed2Formatter,
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.cost - 0) - (b.cost - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          \t￥"), _c('span', {
          staticClass: "red"
        }, [_vm._v(_vm._s(scope.row.cost))])]
      }
    }], null, false, 4160565443)
  }) : _vm._e(), _vm._v(" "), (_vm.list.length > 0 && _vm.list[0]._visit_uv_new != undefined) ? _c('el-table-column', {
    attrs: {
      "prop": "_visit_uv_new",
      "label": "实际计价用户",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a._visit_uv_new - 0) - (b._visit_uv_new - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: scope.row.gray ? 'gray-text' : 'red'
        }, [_vm._v(_vm._s(scope.row._visit_uv_new))])]
      }
    }], null, false, 714932911)
  }) : _vm._e(), _vm._v(" "), (_vm.list.length > 0 && _vm.list[0]._visit_uv != undefined && _vm.pdata.type == 3) ? _c('el-table-column', {
    attrs: {
      "prop": "_visit_uv",
      "label": "实际活跃用户",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a._visit_uv - 0) - (b._visit_uv - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: scope.row.gray ? 'gray-text' : 'red'
        }, [_vm._v(_vm._s(scope.row._visit_uv))])]
      }
    }], null, false, 3331388876)
  }) : _vm._e(), _vm._v(" "), (_vm.list.length > 0 && _vm.list[0]._cost != undefined) ? _c('el-table-column', {
    attrs: {
      "prop": "_cost",
      "label": "实际花费",
      "formatter": _vm.fixed2Formatter,
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a._cost - 0) - (b._cost - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          \t￥"), _c('span', {
          class: scope.row.gray ? 'gray-text' : 'red'
        }, [_vm._v(_vm._s(_vm.fixed2Formatter('', '', scope.row._cost)))])]
      }
    }], null, false, 1363077460)
  }) : _vm._e(), _vm._v(" "), (_vm.list.length > 0 && _vm.list[0].cost_per != undefined && _vm.pdata.type != 3) ? _c('el-table-column', {
    attrs: {
      "prop": "cost_per",
      "label": "实际买量单价",
      "formatter": _vm.fixed2Formatter,
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.cost_per - 0) - (b.cost_per - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          \t￥"), _c('span', {
          staticClass: "red"
        }, [_vm._v(_vm._s(scope.row.cost_per))])]
      }
    }], null, false, 3270957691)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cost_back.day_0",
      "label": "当天回本",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return parseFloat(a.cost_back.day_0) - parseFloat(b.cost_back.day_0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cost_back.day_3",
      "label": "3天回本",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return parseFloat(a.cost_back.day_3) - parseFloat(b.cost_back.day_3)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cost_back.day_7",
      "label": "7天回本",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return parseFloat(a.cost_back.day_7) - parseFloat(b.cost_back.day_7)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cost_back.day_14",
      "label": "14天回本",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return parseFloat(a.cost_back.day_14) - parseFloat(b.cost_back.day_14)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '成本日报详情',
                params: {
                  issued_app_id: scope.row.issued_app_id
                },
                query: {
                  sdate: _vm.pdata.sdate,
                  edate: _vm.pdata.edate
                }
              })
            }
          }
        }, [_vm._v("详情")])]
      }
    }], null, false, 919610758)
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "导入",
      "visible": _vm.batchDialog,
      "width": "1000px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.batchDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.form,
      "label-width": "140px"
    }
  }, [(_vm.batchForm.length == 0) ? _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": _vm.url,
      "headers": _vm.headers,
      "on-success": _vm.batchSuccess,
      "name": "file",
      "show-file-list": false
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传csv文件")])]) : _vm._e()], 1), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('el-row', {
    staticClass: "yltt",
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_vm._v(_vm._s(_vm.batchTips == 0 ? '导入预览' : '导入二次确认'))])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.batchForm), function(item, index) {
    return (_vm.batchForm.length > 0 && _vm.batchTips == '0') ? _c('el-row', {
      staticClass: "yllist",
      class: 'yllist' + index,
      attrs: {
        "gutter": 5
      }
    }, [_vm._l((item), function(citem, idx) {
      return _c('el-col', {
        attrs: {
          "span": 3
        }
      }, [_vm._v("\n       \t\t\t\t" + _vm._s(citem) + "\n       \t\t")])
    }), _vm._v(" "), (index > 0) ? _c('el-col', {
      staticClass: "blue",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "span": 3
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteBatch(index)
        }
      }
    }, [_vm._v("\n       \t\t\t删除\n       \t\t\t\n       \t\t")]) : _vm._e()], 2) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.batchForm), function(item, index) {
    return (_vm.batchForm.length > 0 && _vm.batchTips == '1') ? _c('el-row', {
      staticClass: "yllist",
      class: 'yllist' + index,
      attrs: {
        "gutter": 5
      }
    }, [_vm._l((item), function(citem, idx) {
      return _c('el-col', {
        attrs: {
          "span": idx < 4 ? 3 : 2
        }
      }, [_vm._v("\n       \t\t\t\t" + _vm._s(citem) + "\n       \t\t")])
    }), _vm._v(" "), (index > 0) ? _c('el-col', {
      staticClass: "blue",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "span": 2
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteBatch(index)
        }
      }
    }, [_vm._v("\n       \t\t\t删除\n       \t\t\t\n       \t\t")]) : _vm._e()], 2) : _vm._e()
  }), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.batchCalcel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchSubmit
    }
  }, [_vm._v(_vm._s(_vm.batchTips == '0' ? '确认' : '再次确认'))])], 1) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b8c905f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/income/costDaily.vue
// module id = 1132
// module chunks = 2